import { FadeLoader } from "react-spinners"

export default function Spinner({
  color = "black",
}: {
  color?: "black" | "white"
}) {
  return <FadeLoader color={color} />
}
